import React from 'react'
import { Tooltip } from 'antd'
import { FileOutlined } from '@ant-design/icons'
import Delete from '~/components/deleteConfirm'

/**
 *
 * @param {array} structure array with structure of the table, with the following format:
 * {data_type: "{column data type}", is_searchable: bool, name: "{column name}"}
 * @param {function} handleDelete function to delete a row of the table
 * @returns array with the name of columns of the table
 */
export const getColumns = (
	structure,
	handleDelete,
	handleModalListDocuments
) => {
	if (structure.length === 0) {
		return []
	}

	let columns = structure.map((column) => column.name)

	columns = columns.map((column) => ({
		title: column.charAt(0).toUpperCase() + column.slice(1),
		dataIndex: column,
		key: column,
		editable: true,
	}))

	columns.push({
		title: '',
		dataIndex: 'action',
		key: 'action',
		render: (text, row) => (
			<div style={{ display: 'flex', alignItems: 'right' }}>
				<Delete
					title="Deseja excluir esse texto?"
					handle={() => handleDelete(row)}
				/>
				<div>
					<Tooltip
						placement="top"
						title={'Lista todos os documentos deste item.'}>
						<FileOutlined
							style={{
								fontSize: '20px',
								color: 'var(--ant-primary-color)',
								verticalAlign: 'middle',
								marginLeft: '8px',
							}}
							onClick={() => handleModalListDocuments(row)}
						/>
					</Tooltip>
				</div>
			</div>
		),
	})

	return columns
}

/**
 *
 * @param {array} data array with data of the table
 * @returns function to reestructure the data coming from the backend
 * { key: {row_id}, {column_name}: {column_value}, ..., {column_name}: {column_value}}
 */
export const getDataSource = (data) => {
	return data.map((row) => {
		const entry = {}
		row.data.forEach((val) => {
			entry[val.column] = val.value
		})
		entry['key'] = row.id
		return entry
	})
}
